(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pluff-variant-links"] && !Shopify.designMode) return;
  try {
    class PluffVariantLinks extends HTMLElement {
    connectedCallback() {
      const currentPath = decodeURIComponent(window.location.pathname).toLocaleLowerCase();
      const productTitle = (this.dataset.productTitle || '').toLocaleLowerCase();
      const keywords = (this.dataset.productKeywords || '')
        .split(',')
        .map((keyword) => keyword.trim().toLocaleLowerCase())
        .filter(Boolean);
      const matchesProduct = keywords.some(
        (keyword) => currentPath.includes(keyword) || productTitle.includes(keyword)
      );

      if (!matchesProduct) {
        this.remove();
        return;
      }

      this.syncSelection();
    }

    normalizePath(value) {
      if (!value) return '';

      try {
        const path = new URL(value, window.location.origin).pathname;
        return decodeURIComponent(path).replace(/\/+$/, '').toLocaleLowerCase();
      } catch {
        return '';
      }
    }

    normalizeDimension(value) {
      return (value || '')
        .toLocaleLowerCase()
        .replace(/×/g, 'x')
        .replace(/\s+/g, '')
        .replace(/cm/g, '');
    }

    matchesProductTitle(colorOption) {
      const title = (this.dataset.productTitle || '').toLocaleLowerCase();
      const color = (colorOption.getAttribute('aria-label') || '').trim().toLocaleLowerCase();
      const aliases = {
        storm: ['storm', 'grå', 'gra', 'gray'],
        mokka: ['mokka', 'brun', 'brown'],
        havre: ['havre', 'beige', 'oat'],
      };
      const words = aliases[color] || [color];

      return words.some((word) => title.includes(word));
    }

    syncSelection() {
      const currentPath = this.normalizePath(window.location.href);
      const normalizedTitle = this.normalizeDimension(this.dataset.productTitle);
      const dimensionOptions = Array.from(this.querySelectorAll('[data-dimension-option]'));
      let activeDimension = dimensionOptions.find((dimensionOption) => {
        const normalizedLabel = this.normalizeDimension(dimensionOption.dataset.dimensionLabel);
        return normalizedLabel !== '' && normalizedTitle.includes(normalizedLabel);
      });

      if (!activeDimension) {
        activeDimension = dimensionOptions.find((dimensionOption) => {
          const urls = [
            dimensionOption.dataset.productUrl,
            dimensionOption.dataset.color1Url,
            dimensionOption.dataset.color2Url,
            dimensionOption.dataset.color3Url,
            dimensionOption.dataset.color4Url,
            dimensionOption.dataset.color5Url,
            dimensionOption.dataset.color6Url,
          ].map((url) => this.normalizePath(url));
          return urls.includes(currentPath);
        });
      }

      dimensionOptions.forEach((dimensionOption) => {
        const selected = dimensionOption === activeDimension;
        dimensionOption.classList.toggle('is-selected', selected);
        if (selected) {
          dimensionOption.setAttribute('aria-current', 'page');
        } else {
          dimensionOption.removeAttribute('aria-current');
        }
      });

      const colorOptions = Array.from(this.querySelectorAll('[data-color-option]'));
      if (!colorOptions.length) return;

      let activeColor = colorOptions.find((colorOption) => {
        const colorIndex = colorOption.dataset.colorIndex;
        const matchesDimensionMatrix = dimensionOptions.some(
          (dimensionOption) =>
            this.normalizePath(dimensionOption.dataset[`color${colorIndex}Url`]) === currentPath
        );
        const paths = [
          colorOption.dataset.leftUrl,
          colorOption.dataset.rightUrl,
          colorOption.dataset.defaultUrl,
        ].map((url) => this.normalizePath(url));

        return matchesDimensionMatrix || paths.includes(currentPath);
      });

      if (!activeColor) {
        activeColor = colorOptions.find((colorOption) => this.matchesProductTitle(colorOption));
      }

      if (!activeColor) {
        activeColor = colorOptions.find((colorOption) => colorOption.classList.contains('is-selected'));
      }

      let currentSide = this.dataset.currentSide || '';
      const productTitle = (this.dataset.productTitle || '').toLocaleLowerCase();
      const activeLeftPath = this.normalizePath(activeColor?.dataset.leftUrl);
      const activeRightPath = this.normalizePath(activeColor?.dataset.rightUrl);

      if (activeLeftPath === currentPath && activeRightPath !== currentPath) {
        currentSide = 'left';
      } else if (activeRightPath === currentPath && activeLeftPath !== currentPath) {
        currentSide = 'right';
      } else if (productTitle.includes('vänster') || productTitle.includes('vanster') || productTitle.includes('left')) {
        currentSide = 'left';
      } else if (productTitle.includes('höger') || productTitle.includes('hoger') || productTitle.includes('right')) {
        currentSide = 'right';
      }

      colorOptions.forEach((colorOption) => {
        const selected = colorOption === activeColor;
        colorOption.classList.toggle('is-selected', selected);
        if (selected) {
          colorOption.setAttribute('aria-current', 'page');
        } else {
          colorOption.removeAttribute('aria-current');
        }

        const sideUrl =
          currentSide === 'right' ? colorOption.dataset.rightUrl : colorOption.dataset.leftUrl;
        const dimensionUrl =
          activeDimension?.dataset[`color${colorOption.dataset.colorIndex}Url`] || '';
        const targetUrl = dimensionUrl || sideUrl || colorOption.dataset.defaultUrl || '';
        if (targetUrl) {
          colorOption.setAttribute('href', targetUrl);
        } else {
          colorOption.removeAttribute('href');
        }
      });

      if (!activeColor) return;

      const activeColorIndex = activeColor.dataset.colorIndex;
      dimensionOptions.forEach((dimensionOption) => {
        const targetUrl =
          dimensionOption.dataset[`color${activeColorIndex}Url`] ||
          dimensionOption.dataset.productUrl ||
          '';
        if (targetUrl) {
          dimensionOption.setAttribute('href', targetUrl);
        } else {
          dimensionOption.removeAttribute('href');
        }
      });

      const fallbackUrl = activeColor.dataset.defaultUrl || '';
      this.querySelectorAll('[data-orientation]').forEach((orientationOption) => {
        const side = orientationOption.dataset.orientation;
        const targetUrl =
          (side === 'right' ? activeColor.dataset.rightUrl : activeColor.dataset.leftUrl) ||
          fallbackUrl;
        const selected = side === currentSide;

        orientationOption.classList.toggle('is-selected', selected);
        if (selected) {
          orientationOption.setAttribute('aria-current', 'page');
        } else {
          orientationOption.removeAttribute('aria-current');
        }

        if (targetUrl) {
          orientationOption.setAttribute('href', targetUrl);
        } else {
          orientationOption.removeAttribute('href');
        }
      });
    }
  }

  if (!customElements.get('pluff-variant-links')) {
    customElements.define('pluff-variant-links', PluffVariantLinks);
  }
  } catch(e) { console.error(e); }
})();

})();
